import { BetTypes } from "../../../types";
export const isYourBet = (betType) => {
    return betType === BetTypes.YourBet;
};
//# sourceMappingURL=isYourBet.js.map